<template>
  <div class='Box'>
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="manageBlockEdit" :before-close="AddNone" size="40%" direction="rtl">

      <div class="demo-drawer__content">

      <el-form :model="addFrom" size="medium" label-width="100px" class="mt35" :rules="rules" ref="ruleForm">

        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
          <el-form-item label="推荐位名称" prop="name">
            <el-input v-model="addFrom.name" placeholder="请输入推荐位名称" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
          <el-form-item label="应用" prop="platform_type">
            <el-select v-model="addFrom.platform_type" class="w100" disabled placeholder="请选择平台类型">
              <el-option label="抖音" :value="1"></el-option>
              <el-option label="微信" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
          <el-form-item label="推荐位类型" prop="type">
            <el-select placeholder="请选择推荐位类型" class="w100" v-model="addFrom.type">
              <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="15" :xl="22" class="mb20">
          <el-form-item label="排序" prop="weigh">
            <el-input v-model="addFrom.weigh" placeholder="请输入排序" clearable></el-input>
          </el-form-item>
        </el-col>

      </el-form>

      </div>

      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>

    </el-drawer>
  </div>
</template>

<script>

import {manageBlockAPI} from "@/api/appletlist/manageBlock";
import { processErrors } from "@/utils/errorHandler";

export default {
  props: ['manageBlockEdit', "editID","platformType"],
  components: {},
  data() {
    return {
      title: "新增",

      addFrom: {
        id: '',
        name: '',
        platform_type: '',
        type: '',
        weigh: '',
      },
      typeList: [
        {id: 1, name: 'Banner'},
        {id: 2, name: '强烈推荐'},
        {id: 3, name: '精品热门'},
        {id: 4, name: '多人收藏'},
        {id: 5, name: '热门榜'},
        {id: 6, name: '新书榜'},
        {id: 7, name: '收藏榜'},
      ],
      rules: {
        name: [
          {required: true, message: '请输入推荐位名称', trigger: 'blur'},
        ],
        platform_type: [
          {required: true, message: '请选择平台类型', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '请选择推荐位类型', trigger: 'blur'},
        ],
        weigh: [
          {required: true, message: '请输入排序', trigger: 'blur'},
        ],
      },

    };
  },
  created() {

  },

  methods: {

    AddNone() {
      this.addFrom = {}
      this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NoneManageBlockFlag');
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let api = manageBlockAPI()
          api.editManageBlock(this.addFrom).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              });
              this.$emit('AddManageBlockok');
            }else{
              processErrors(res);
            }

          })
        } else {
          return false;
        }
      });

    }
  },

  mounted() {
    this.addFrom.platform_type = +this.platformType;
    if (this.editID) {
      this.title = "编辑"
      let api = manageBlockAPI()
      api.getManageBlockInfo(this.editID).then(res => {
        if (res.code == 0) {
          this.addFrom.id = res.data.id;
          this.addFrom.name = res.data.name;
          this.addFrom.type = res.data.type;
          this.addFrom.platform_type = res.data.platform_type;
          this.addFrom.weigh = res.data.weigh;
        } else {
          processErrors(res);
        }
      })
    } else {
    }
  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 0 !important;
    }
  }
}

/* 自定义样式，改变节点颜色 */
.highlighted {
  color: blue !important;
}
.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>
